<script setup lang="ts">
export interface StoryblokPageProps {
    blok: StoryblokPage;
}

// PROPS
const { blok } = defineProps<StoryblokPageProps>();
</script>

<template>
    <div v-editable="blok">
        <StoryblokComponent v-for="b in blok.body" :key="b._uid" :blok="b" />
    </div>
</template>
